module.exports = __webpack_public_path__ + "media/images/icon_furikaeri-9df1ff9942a836a7b841a286bb8f4933.svg";